import React from 'react';

const StackedImageIcon = ({ note, isLoading, onClick }) => {
  const imageCount = note.inlineImageCount || 0;
  if (!imageCount) return null;

  if (isLoading) {
    return (
      <button className="image-icon-btn" style={{ opacity: 0.5, marginRight: '4px' }} title="Loading images...">
        <i className="fas fa-spinner fa-spin" />
      </button>
    );
  }

  return (
    <div
      className="inline-image-icon"
      style={{ display: 'inline-flex', alignItems: 'center', marginRight: '4px', position: 'relative', cursor: 'pointer' }}
      onClick={(e) => { e.stopPropagation(); onClick(note); }}
      title={`${imageCount} inline image${imageCount !== 1 ? 's' : ''} - Click to view`}
    >
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <i
          className="fas fa-image"
          style={{ fontSize: '18px', color: '#3498db', transition: 'all 0.2s ease' }}
          onMouseEnter={(e) => { e.target.style.transform = 'scale(1.2)'; e.target.style.color = '#2980b9'; }}
          onMouseLeave={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.color = '#3498db'; }}
        />
        <div style={{ position: 'absolute', top: '-5px', right: '-5px', backgroundColor: '#e74c3c', color: 'white', fontSize: '9px', fontWeight: 'bold', minWidth: '16px', height: '16px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid white', boxShadow: '0 1px 3px rgba(0,0,0,0.2)', padding: '0 2px' }}>
          {imageCount}
        </div>
      </div>
    </div>
  );
};

export default React.memo(StackedImageIcon);